// Patch touch event listeners to be passive by default.
// Prevents "[Intervention] Ignored attempt to cancel a touchmove event
// with cancelable=false" warnings from DevExtreme components.
(function patchPassiveTouchEvents() {
  const originalAddEventListener = EventTarget.prototype.addEventListener;
  const passiveTouchEvents = new Set(['touchstart', 'touchmove']);

  EventTarget.prototype.addEventListener = function (
    type: string,
    listener: EventListenerOrEventListenerObject | null,
    options?: boolean | AddEventListenerOptions
  ) {
    if (passiveTouchEvents.has(type)) {
      if (typeof options === 'boolean') {
        options = { capture: options, passive: true };
      } else if (options == null) {
        options = { passive: true };
      } else if (options.passive === undefined) {
        options = { ...options, passive: true };
      }
    }
    return originalAddEventListener.call(this, type, listener, options);
  };
})();

//Angular imports
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

// Configure DevExtreme license
import { configureLicense } from './app/devextreme-license';
configureLicense();

import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
